import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useActivityScene } from 'common/helper/scene';

import GlobalNotification from '@tiangong/components/GlobalNotification';
import { TiangongConfigProvider } from '@tiangong/components/TiangongConfigProvider';

import { ExternalRoutes } from '@tiangong/router/ExternalRoutes';

const router = createBrowserRouter(ExternalRoutes);

export const BlankLayout = () => {
  const { isActivityScene } = useActivityScene();

  return (
    <TiangongConfigProvider>
      {!isActivityScene && <GlobalNotification />}
      <RouterProvider router={router} />
    </TiangongConfigProvider>
  );
};
